import { render } from "./CardsList.vue?vue&type=template&id=1154c4a9&scoped=true"
import script from "./CardsList.vue?vue&type=script&lang=js"
export * from "./CardsList.vue?vue&type=script&lang=js"

import "./CardsList.vue?vue&type=style&index=0&id=1154c4a9&scoped=true&lang=css"
import "./CardsList.vue?vue&type=style&index=1&id=1154c4a9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1154c4a9"]])

export default __exports__